import Home from './components/Home'

export const routes = [
    { path:'', component: Home  },
    { path:'/:id', component: Home }
]
export default routes
